import { StyleProp, View, ViewStyle } from 'react-native';

export function Divider({ style }: { style?: StyleProp<ViewStyle> }) {
  return <View style={[{ height: 1, backgroundColor: '#E2E2E9', marginVertical: 10 }, style]} />;
}

export default Divider;
